import { render, staticRenderFns } from "./surgery_list.vue?vue&type=template&id=0fb38cf6&"
import script from "./surgery_list.vue?vue&type=script&lang=js&"
export * from "./surgery_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports